<div id="spinner" *ngIf="spinnerService.active">
  <mat-progress-spinner [mode]="spinnerService.mode" [color]="spinnerService.color"></mat-progress-spinner>
</div>